export const PRINTFUL_SYNC_PRODUCTS_FIELDS_LIST: any = [
    {attribute: "id", label: "Id", cssClass: ''},
    {attribute: "external_id", label: "External Id", cssClass: ''},
    {attribute: "thumbnail_url", label: "Image", cssClass: '', isImage: true},
    {attribute: "name", label: "Name", cssClass: ''},
    {attribute: "variants", label: "Variants", cssClass: ''},
    {attribute: "synced", label: "Synced", cssClass: ''},
    {attribute: "is_ignored", label: "Is Ignored", cssClass: ''},
];


export const PRINTFUL_SYNC_PRODUCTS_INPUT_FIELDS: any = [
    {attribute: "id", label: "Id", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "external_id", label: "External Id", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "is_ignored", label: "Is Ignored", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "name", label: "Name", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "synced", label: "Synced", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "thumbnail_url", label: "Thumbnail Url", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "variants", label: "Variants", type: 'text', group: 'detail', cssClass: ''},
];
